import { z } from 'zod';

export const SiteSchema = z.object({
  id: z.string(),
  fullFrontendId: z.string(),
});

export type Site = z.infer<typeof SiteSchema>;
